import { initialServerApi } from '../constants/ApiConfigs';
import axios from 'axios';
const handleSetFavicon = (faviconUrl) => {
  if (!faviconUrl) {
    faviconUrl = '%PUBLIC_URL%/favicon.ico?v=1';
  };

  const head = document.getElementsByTagName('head')[0];

  const links = head.querySelectorAll(
    "link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']"
  );
  links.forEach((link) => head.removeChild(link));

  const timestamp = `?v=${Date.now()}`;

  const icon = document.createElement('link');
  icon.rel = 'icon';
  icon.type = 'image/png';
  icon.href = faviconUrl + timestamp;
  head.appendChild(icon);

  const shortcut = document.createElement('link');
  shortcut.rel = 'shortcut icon';
  shortcut.href = faviconUrl + timestamp;
  head.appendChild(shortcut);

  const apple = document.createElement('link');
  apple.rel = 'apple-touch-icon';
  apple.href = faviconUrl + timestamp;
  head.appendChild(apple);
};

const handleLoadSettingServer = () => {
  axios
    .post(
      initialServerApi,
      { clientUrl: window.location.origin },
      { headers: { 'Content-Type': 'application/json' } }
    )
    .then((res) => {
      if (res?.data?.res?.favicon) {
        handleSetFavicon(res.data.res.favicon);
      } else {
        handleSetFavicon('');
      }
    })
    .catch((error) => handleSetFavicon(''));
};

export default handleLoadSettingServer;
